module.exports = __webpack_public_path__ + "img/youtube.f416f29e.png";